/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum expertIncludeEnum {
    ALL = 'all',
    EXPERT = 'expert',
    NON_EXPERT = 'non_expert',
}